import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'
gsap.registerPlugin(ScrollTrigger, SplitText)

export const animation = () => {
	text()
	images()
}

const text = () => {

	let els = document.querySelectorAll('[data-animation="text-block"]')

	if (!els.length) return

	document.fonts.ready.then(() => {
		els.forEach(el => {

			el.style.opacity = 1

			let start = el.hasAttribute('data-start') ? el.getAttribute('data-start') : 'top 75%'

			let nodes = el.querySelectorAll('.kicker, h1, h2, h3, address, p, ol, ul, .button')

			let tl = gsap.timeline({
				scrollTrigger: {
					trigger: el,
					start: start,
					toggleActions: "play none none reverse",
					// markers: true,
				},
			})

			nodes.forEach((node, i) => {

				if (node.classList.contains('kicker')) {

					kicker(tl, node)

				} else if (node.tagName == 'H1' || node.tagName == 'H2' || node.tagName == 'H3' || node.tagName == 'ADDRESS') {

					heading(tl, node, (i == 0 ? 0 : '-=0.3'))

				} else if (node.tagName == 'P' || node.tagName == 'UL') {

					body(tl, node, '-=0.7')

				} else if (node.classList.contains('button')) {

					button(tl, node, '-=0.5')

				}
			})
		})
	})
}


export const kicker = (tl, node) => {

	let outer = document.createElement('span'),
		inner = document.createElement('span')

	outer.classList.add('out')
	inner.classList.add('in')

	outer.appendChild(inner)
	inner.textContent = node.textContent

	node.innerHTML = outer.outerHTML

	tl.fromTo(node.querySelector('.in'), {
		x: '-100%',
		opacity: 0,
	}, {
		x: 0,
		opacity: 1,
		duration: 0.8,
		ease: 'power2.out',
	})

}

export const heading = (tl, node, delay) => {

	let split = new SplitText(node, { type: 'words', wordsClass: 'word' })

	tl.fromTo(split.words, {
		opacity: 0,
		y: '50%',
	}, {
		y: 0,
		opacity: 1,
		stagger: 0.05,
		duration: 1.4,
		ease: 'power2.out',
	}, delay)

}

export const body = (tl, node, delay) => {

	let split = new SplitText(node, { type: 'lines', linesClass: 'line' })

	tl.fromTo(split.lines, {
		opacity: 0,
		y: '100%',
	}, {
		y: 0,
		opacity: 1,
		stagger: 0.125,
		duration: 1,
		ease: 'power2.out',
	}, delay)
}

export const button = (tl, node, delay) => {

	tl.fromTo(node, {
		opacity: 0,
		scale: 0.9,
	}, {
		opacity: 1,
		scale: 1,
		duration: 0.6,
		ease: 'power2.out',
	}, delay)
}

const images = () => {

	let els = document.querySelectorAll('[data-animation="image"]')

	if (!els.length) return

	els.forEach(el => {

		let i = document.createElement('i')

		el.appendChild(i)

		el.style.opacity = 1

		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: el,
				start: 'top 70%',
				delay: 2,
				// markers: true,
			},
		})

		let image = el.querySelector('img'),
			shutter = el.querySelector('i')

		tl.fromTo(shutter, {
			scaleY: 0,
		}, {
			scaleY: 1,
			duration: 1.2,
			ease: 'power3.out',
		})

		tl.fromTo(image, {
			opacity: 0,
			scale: 1.1,
		}, {
			opacity: 1,
			scale: 1,
			duration: 0.8,
		}, '-=0.4')

	})
}

export default () => { }